<template>
    <div>
        
        <!-- <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Frowsanapparel&tabs=timeline&width=400&height=200&small_header=false&adapt_container_width=false&hide_cover=false&show_facepile=false&appId=161424020891961" width="400" height="200" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe> -->
        
        <div class="fb-page" data-href="https://www.facebook.com/rowsanapparel" data-tabs="timeline" data-width="300" data-height="200" data-small-header="false" data-adapt-container-width="false" data-hide-cover="false" data-show-facepile="false"><blockquote cite="https://www.facebook.com/rowsanapparel" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/rowsanapparel">Rowsan Apparel</a></blockquote></div>
    </div>
  </template>
  
  <script setup>
  import { onMounted } from 'vue'
  
  onMounted(() => {
    setTimeout(() => {
      
    }, 1000);

    
  })
  </script>